import { createAction, props } from '@ngrx/store';

export const loadDocumentTypes = createAction('[DocumentType] Load DocumentTypes', props<{ isMinor?: boolean }>());

export const loadDocumentTypesSuccess = createAction('[DocumentType] Load DocumentTypes Success', props<{ response: any }>());

export const loadDocumentTypesFailure = createAction('[DocumentType] Load DocumentTypes Failure', props<{ error: Error | any }>());
